const PURPLE = '#5236AB';

const styles = {
  treeRoot: { display: 'flex', flexDirection: 'column', height: '100%' },

  unitDetailsTreeContainer: {
    flexGrow: 1,
    minHeight: 0,
    overflowY: 'auto',
    p: 0.5,
  },

  unitDetailsTreeDivider: {
    mb: 0.5,
    color: PURPLE,
    fontFamily: 'Source Sans Pro',
    fontWeight: 500,
    lineHeight: 1.25,                
    '& .MuiDivider-wrapper': {
      width: '20%',
      m: 0,
      mx: 0.3,                        
      px: 0,
      py: 0,
      fontSize: '0.95rem',
      lineHeight: 1.25,
    },
    '&::before, &::after': { borderTopColor: PURPLE },
  },

  unitDetailsListItem: {
    pl: 0,
    color: PURPLE,
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: 1,
    cursor: 'default',
    overflow: 'visible',
    py: 0.25,
    minHeight: 'unset',
  },

  chevronButton: {
    width: 28, height: 28, p: 0, mr: 0.5, borderRadius: '50%',
    display: 'grid', placeItems: 'center',
    '& svg': { width: 18, height: 18, display: 'block', lineHeight: 0 },
    '&:hover': { backgroundColor: 'action.hover' },
    '&:focus-visible': { outline: '2px solid #5236AB99', outlineOffset: 2 },
  },

  unitDetailsTreeIcon: { color: PURPLE },
  unitDetailsTreeTrainIcon: { mr: 0.75, color: PURPLE },

  evnTextLink: {
    fontFamily: 'Source Sans Pro',
    fontSize: '0.95rem',
    color: PURPLE,
    cursor: 'pointer',
    textDecoration: 'none',
    display: 'inline-block',
    userSelect: 'none',
    lineHeight: 1.25,
    '&:hover': { textDecoration: 'underline' },
    '&:focus-visible': { outline: '2px solid #5236AB99', outlineOffset: 2, borderRadius: 2 },
  },

  unitDetailsTreeMeterDivider: {
    ml: 5.5,
    mt: 0.25,
    mb: 0.25,
    color: PURPLE,
    fontFamily: 'Source Sans Pro',
    fontWeight: 500,
    lineHeight: 1.25,
    '& .MuiDivider-wrapper': {
      width: '33%',                  
      m: 0,
      mx: 0.3,                        
      px: 0,
      py: 0,
      fontSize: '0.95rem',
      lineHeight: 1.25,
    },
    '&::before, &::after': { borderTopColor: PURPLE },
  },

  unitDetailsTreeMeterButton: {
    pl: 5.5,
    color: PURPLE,
    justifyContent: 'flex-start',
    py: 0.25,
    minHeight: 'unset',
    '&:hover': { textDecoration: 'underline' },
  },

  unitDetailsTreeMeterIcon: { mr: 0.75, color: PURPLE },

  meterTextLink: {
    fontFamily: 'Source Sans Pro',
    fontSize: '0.95rem',
    color: PURPLE,
    cursor: 'pointer',
    textDecoration: 'none',
    display: 'inline-block',
    userSelect: 'none',
    lineHeight: 1.25,
    '&:hover': { textDecoration: 'underline' },
    '&:focus-visible': { outline: '2px solid #5236AB99', outlineOffset: 2, borderRadius: 2 },
  },
};

export default styles;
